
  <footer @click="show = true" class="footer">
    <div>
      {{ id }}<span>/{{ $store.getters.getAnswers.length }}</span>
    </div>
    <div>
      跳转
    </div>
  </footer>
  <Action-Sheet v-model:show="show" description="题目总览" cancel-text="关闭">
    <ul class="content">
      <li
        @click="handleJumpClick(index)"
        v-for="(item, index) in $store.getters.getAnswers"
        :key="index"
        class="ques-item"
        :class="{
          finished:
            (item &&
              JSON.stringify(item?.value) !== '[]' &&
              item.value &&
              item.value[0]) ||
            (item?.questionType === 18 &&
              JSON.stringify(item?.answers) !== '[]'),
          current: index === id - 1
        }"
      >
        {{ index + 1 }}
      </li>
    </ul>
    <Loading v-if="partLoading" class="loading" type="spinner"
      >加载中...</Loading
    >
  </Action-Sheet>
